import { berlinUhrzeit, berlinZeitpunkt, personImText } from "@dj/domain/gemeinsam";
import { useParams } from "react-router";
import { Status } from "../design/Hinweis";
import { AnsichtDerDrueckjagd } from "./AnsichtDerDrueckjagd";
import type { Zustandsanzeige } from "./jagdzustand";

/** Hinweis F-090 (oberflaeche.md §4.1, §9): steht beim Jagdzustand in jedem Zustand, auch ohne Netz. */
export const SIGNALE_VOR_ORT = "Die App ergänzt Jagdsignale und Anweisungen vor Ort, sie ersetzt sie nicht.";

const KEIN_WERT = "—";

function zeilen(a: Zustandsanzeige): Array<[string, string]> {
  const e = a.eingriff;
  return [
    ["Jagdzustand", a.zustand],
    ["Text", a.darstellung.text],
    ["Letzter Eingriff", e ? `${e.art}, ${personImText(e.name, e.rolle, e.anrede)}, ${berlinUhrzeit(e.zeitpunkt)}` : KEIN_WERT],
    ["Grund", e?.grund ?? KEIN_WERT],
    ["Nächster geplanter Wechsel", a.naechster ? `${berlinZeitpunkt(a.naechster.Zeitpunkt)}, ${a.naechster.Jagdzustand}` : KEIN_WERT],
    ["Letzter Abgleich", a.kontakt.letzterAbgleich ? berlinZeitpunkt(a.kontakt.letzterAbgleich) : KEIN_WERT],
    ["Hinweis", a.kontakt.keinKontaktSeit ? `kein Kontakt seit ${berlinUhrzeit(a.kontakt.keinKontaktSeit)}` : KEIN_WERT],
  ];
}

/**
 * Angaben zum Jagdzustand (oberflaeche.md §3.2, §4.1): geöffnet über die Statusleiste; Zeilen als `row` mit
 * `rowheader` = Feld und `cell` = Wert, Personen mit Rollenbezeichnung nach Anrede (ADR-0025), dazu der Hinweis auf die
 * Signale vor Ort und „Zurück“.
 */
export function AngabenZumJagdzustand() {
  const { id = "" } = useParams();
  // Referenz `#s-angaben`: Hinweis F-090 zuerst, dann die Zeilen (`row` mit `rowheader`/`cell`); „Zurück“ oben links
  return (
    <AnsichtDerDrueckjagd drueckjagdId={id} name="Angaben zum Jagdzustand">
      {(a) => (
        <>
          <Status>{SIGNALE_VOR_ORT}</Status>
          <table className="anrufzeilen platte" role="table">
            <tbody>
              {zeilen(a).map(([feld, wert]) => (
                <tr key={feld} role="row">
                  <th scope="row" role="rowheader">{feld}</th>
                  <td role="cell">{wert}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </AnsichtDerDrueckjagd>
  );
}
